import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as ticketAction from './../../../../actions/ticketAction';
import Tickets from './Tickets';

const mapStateToProps = state => {
    return {
        ticketState: state.ticketReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTickets: (params) => dispatch(ticketAction.getTicketList(params)),
        updateTicket: (ticket) => dispatch(ticketAction.updateTicket(ticket)),

    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Tickets));
